// Surveille l'inactivité sur la tablette du magasin (mode tablette) :
// après 2 min sans toucher l'écran, l'employé est déconnecté et on revient à la connexion.
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { clearEmployeeToken, getEmployeeToken } from '../lib/employeeApi'
import { isKiosk, KIOSK_IDLE_MS, KIOSK_WARN_MS } from '../lib/kiosk'

export default function KioskWatcher() {
  const nav = useNavigate()
  const location = useLocation()
  const last = useRef(Date.now())
  const [left, setLeft] = useState<number | null>(null)

  const active = isKiosk()
    && location.pathname.startsWith('/app')
    && !location.pathname.startsWith('/app/login')
    && !location.pathname.startsWith('/app/tablette')
    && !!getEmployeeToken()

  useEffect(() => {
    if (!active) { setLeft(null); return }
    last.current = Date.now()
    const touch = () => { last.current = Date.now(); setLeft(null) }
    const events = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel']
    events.forEach(e => window.addEventListener(e, touch, { capture: true, passive: true }))
    const timer = setInterval(() => {
      const idle = Date.now() - last.current
      if (idle >= KIOSK_IDLE_MS) {
        clearEmployeeToken()
        setLeft(null)
        nav('/app/login', { replace: true })
      } else if (idle >= KIOSK_IDLE_MS - KIOSK_WARN_MS) {
        setLeft(Math.ceil((KIOSK_IDLE_MS - idle) / 1000))
      }
    }, 1000)
    return () => {
      events.forEach(e => window.removeEventListener(e, touch, { capture: true } as any))
      clearInterval(timer)
    }
  }, [active, nav])

  if (!active || left === null) return null
  return (
    <div className="fixed inset-x-0 top-0 z-[100] bg-amber-500 text-white text-center py-3 px-4 font-semibold shadow-lg">
      Déconnexion automatique dans {left} s — touchez l’écran pour continuer
    </div>
  )
}
